module.exports = __webpack_public_path__ + "static/media/icons-sprite.7a716999.svg";